import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { pathOr } from 'ramda';

import {
  defaultOptions,
  dropdownOptions,
} from 'components/FormSelect/FormSelect.helpers';

export type ConfidenceVals = 0 | 1 | 2;

export type StatSigExperiment = {
  numTransactors: number;
  resultConfidence: ConfidenceVals;
};

export type Merchant = {
  merchantName: string;
  merchantId: string;
  offerNetworkExternalVenueId: string;
  firstLiveDate: string;
  hasThirdPartyData: boolean;
  onlineOnly: boolean;
  hasOnlineVenue: boolean;
  statSig: StatSigExperiment;
};

const GET_MERCHANTS = gql`
  query GetMerchants($params: MerchantSearchInput) {
    merchantList(params: $params) {
      result {
        merchantName
        merchantId
        offerNetworkExternalVenueId
        firstLiveDate
        hasThirdPartyData
        onlineOnly
        hasOnlineVenue
        statSig {
          numTransactors
          resultConfidence
        }
      }
    }
  }
`;

export const useMerchants = () => {
  const initialMerchantsList = dropdownOptions(
    'Merchant',
    'Select Merchant...',
  );
  const [merchantDropdownOptions, setMerchantOptions] = useState(
    initialMerchantsList,
  );

  const [merchants, setMerchants] = useState<Merchant[]>();

  const { data, loading: merchantsLoading } = useQuery(GET_MERCHANTS, {
    variables: {
      params: {
        pagingInput: {
          offset: 0,
          limit: 800,
        },
      },
    },
  });

  useEffect(() => {
    const merchants = pathOr(
      [],
      ['merchantList', 'result'],
      data,
    ) as Merchant[];
    const merchantsCopy = initialMerchantsList;
    merchantsCopy.options = [defaultOptions];
    merchants.forEach((merchant) => {
      merchantsCopy.options.push({
        key: merchant.merchantId,
        value: merchant.merchantId,
        text: merchant.merchantName,
      });
    });
    setMerchants(merchants);
    setMerchantOptions(merchantsCopy);
  }, [data]);

  return {
    merchantsLoading,
    merchantDropdownOptions,
    merchants,
  };
};
